<script lang="ts">
import FaChartLine from 'svelte-icons/fa/FaChartLine.svelte';
import FaTable from 'svelte-icons/fa/FaTable.svelte';
import FaSortNumericUpAlt from 'svelte-icons/fa/FaSortNumericUpAlt.svelte';
import { Visualizations } from "../data-views/options";
import { tick } from 'svelte';
import { t } from "../translations/i18n";

export let handler = (visualization_type: any) => {};

/**
   * Handle keyboard events
   * @param event - The keyboard event
   * @returns void
  */
  const onKeyDown = async (event: KeyboardEvent): Promise<void> => {

    // Get all buttons
    const visualisationSelectorContainer = document.getElementById('visualization-selector');
    const buttons = visualisationSelectorContainer?.querySelectorAll('button');

    // Find the index of the currently focused element from navbarElements
    if (!buttons) return;
    let focusedElementIndex = Array.from(buttons).findIndex((element: Element) => 
      element === document.activeElement || element.contains(document.activeElement)
    );

    switch (event.key) {

      case "Enter":
        // Click the focused element
        buttons[focusedElementIndex].click();

        // Set the focus to the new visualization, when you create a new visualization
        await tick();
        (document.querySelectorAll('[id^="container-id-"]')[0] as HTMLElement).focus();
        break;

      case "ArrowRight":
        // Go to the next element
        buttons[focusedElementIndex + 1].focus();
        break;

      case "ArrowLeft":
        // Go to the previous element
        buttons[focusedElementIndex - 1].focus();
        break;

      default:
        // Allow default behavior for other keys
        return;
    }

    // Prevent default behavior only for relevant keys
    event.preventDefault();
  };

</script>

<div class="visualization-selector" id="visualization-selector" tabindex="0" on:keydown={onKeyDown}>
    <div class="content-wrapper">
        <h2>{$t("Start with your first visualization")}</h2>
        <div class="buttons">
            <!-- Chart -->
            <div class="button-wrapper scale-up" style="--order:1;">
            <button type="button" on:click={() => {handler(Visualizations.CHART)}}>
                <div class="selector-icon">
                    <FaChartLine />
                </div>
                <p>{$t("Chart")}</p>
            </button>
            </div>

            <!-- Table -->
            <div class="button-wrapper scale-up" style="--order:2;">
            <button type="button" on:click={() => {handler(Visualizations.TABLE)}}>
                <div class="selector-icon">
                    <FaTable />
                </div>
                <p>{$t("Table")}</p>
            </button>
            </div>

            <!-- Figure -->
            <div class="button-wrapper scale-up" style="--order:3;">
            <button type="button" on:click={() => {handler(Visualizations.FIGURE)}}>
                <div class="selector-icon">
                    <FaSortNumericUpAlt />
                </div>
                <p>{$t("Figure")}</p>
            </button>
            </div>
        </div>
    </div>
</div>


<style lang="scss">
*,
::before,
::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
:root {
  --clr-bg: #efefef;
  --clr-primary: #0f172a;
  --easing: cubic-bezier(0.47, 1.64, 0.41, 0.8);
}

.visualization-selector {
    width: 100%;
    display: flex;
    justify-content: center;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
}

.selector-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75%;
    height: 75%;
    margin-top: 0.5rem;
}

/* reset button */
input,
button {
  appearance: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
  text-transform: none;
  line-height: normal;
  overflow: visible;
  display: flex;
  justify-content: center;
}
body {
  margin: 0;
  padding: 2rem;
  display: grid;
  place-items: center;
  min-height: 100vh;
  color: #ffffff30;
  background: var(--clr-primary);
  font-family: poppins, sans-serif;
}
.buttons {
    max-width: 500px;
    width: auto;
    border-radius: 20px;
    background-color: #00000050;
    border: 1px solid #ffffff30;
    padding: 2rem;
    backdrop-filter: blur(12px);
    display: grid;
    // grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    gap: 3rem;
    position: relative;
}
.buttons::before{
    content: '';
    position: absolute;
    inset: 0;
    background-color: #00000020;
    z-index: -1;
    border-radius: inherit;
    transition: inset 500ms ease-in-out;
}
.buttons:hover::before{
    inset: -1rem;
    transition-timing-function: cubic-bezier(
    0.47,
    1.64,
    0.41,
    0.8
  );
}
.buttons button {
  background-color: #00000050;
  border: 1px solid #ffffff30;
  padding: 1rem;
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  border-radius: 5px;
  outline: none;
  overflow: hidden;
  cursor: pointer;
  transition: 300ms ease-in-out;
  position: relative;
  isolation: isolate;
  color: #ffffff90;
}

.buttons .button-wrapper {
  max-width: 6rem;
  width: 100%;
}

.buttons button p {
  position: absolute;
  width: 100%;
  font-size: 0.8rem;
  opacity: 0;
  left: 0;
  bottom: 0rem;
  padding: 0.3rem;
  text-align: center;
  transition: all 150ms ease-in-out 0ms;
  outline: none;
  translate: 0 10px;
  font-weight: bold;
}
.buttons button:hover p {
  opacity: 1;
  translate: 0;
  transition: all 150ms ease-in-out 150ms;
}

.buttons button:focus-visible,
.buttons button:hover {
  transform: scale(1.15);
  z-index: 10;
  color: #fff;
  background-color: var(--color-primary);
}
.buttons:has(button:focus-visible) button:not(:focus-visible),
.buttons:has(button:hover) button:not(:hover) {
  opacity: 50%;
  scale: 85%;
  z-index: -10;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    --d: 0;
    --ani-speed: 300ms;
  }

  [slide-in-left] {
    opacity: 0;
    translate: -500px 0;
    animation: slide-in var(--ani-speed) ease-out forwards;
    animation-delay: calc(var(--order, 0ms) * var(--ani-speed));
  }

  [slide-in-right] {
    opacity: 0;
    translate: 500px 0;
    animation: slide-in var(--ani-speed) ease-out forwards;
    animation-delay: calc(var(--order, 0ms) * var(--ani-speed));
  }

  [slide-in-top] {
    opacity: 0;
    translate: 0 -500px;
    animation: slide-in var(--ani-speed) ease-out forwards;
    animation-delay: calc(var(--order, 0ms) * var(--ani-speed));
  }

  [slide-in-bottom] {
    opacity: 0;
    translate: 0 500px;
    animation: slide-in var(--ani-speed) ease-out forwards;
    animation-delay: calc(var(--order, 0ms) * var(--ani-speed));
  }
  
  .scale-up {
    scale: 0;
    animation: scale-up var(--ani-speed) forwards;
    animation-delay: calc(var(--order, 0ms) * var(--ani-speed));
  }

  [scale-from-top] {
    transform-origin: top;
    scale: 1 0;
    animation: scale-up var(--ani-speed) forwards;
    animation-delay: calc(var(--order, 0ms) * var(--ani-speed));
  }


}

@keyframes slide-in {
  from {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  to {
    opacity: 1;
    translate: 0;
  }
}

@keyframes scale-up {
  0% {
    scale: 0;
  }

  60% {
    scale: 1.15;
  }

  100% {
    scale: 1;
  }
}


</style>